<template>
  <Navbar/>
  <router-view/>
  <Bottom/>
</template>
<script setup>
import Navbar from "@/components/Navbar.vue";
import Bottom from "@/components/Bottom.vue"
</script>

<style lang="scss">


</style>
